import React, { useState, useEffect, useRef, useMemo,Suspense, lazy } from "react";
import InfoQuestionIconSVG from "assets/svg/info-question-mark-icon";
import PlayIconSmallSVG from "assets/svg/play-icon";
import json from "assets/json/popup-info.json";
import _ from "lodash";
import styled from "styled-components";
import { useTranslation,Trans } from "react-i18next";
import { currentLang } from "utils/utils";
import { useVideoPlayer } from "context/videoPlayerContext";

export default function PopInfo({
  containerClass = "relative top-0.5",
  type = "milestones",
  direction = "left",
  onClickCallBack = () => {},
  responsive = { left: "135px", right: "135px", arrow_left:"135px", arrow_right:"135px" },
  verticalDirection = null,
  setShowMedia = ()=> false,
  showMediaHandle = ()=> {}, 
  borderColor="border-lightBlack",
  topCss ="-11.5rem",
  small=false,
  hideArrow=false
}) {
  const MediaPreview = lazy(() => import('components/profile/milestones/media-button/watch-instruction')); 
  const {t} = useTranslation();
  const lang = currentLang();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);
  const [position, setPosition] = useState({ vertical: "bottom", horizontal: direction });
  const { openVideo,titleName } = useVideoPlayer();
  // outside clicks
  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (open) {
            setOpen(false);
          }
        }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref, open]);
  };

  useOutsideAlerter(wrapperRef);
  // =========================== useMemo ================================
  const content = useMemo(() => {
    let result = _.find(json, { key: type });
    return result;
  }, [type]);

  
   const checkPosition = () => {
    let vertical = "bottom";

    if(verticalDirection){
      vertical = verticalDirection;
      setPosition({ vertical });
      return;
    }
    if (!wrapperRef.current) return;

    const rect = wrapperRef.current.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    // const windowWidth = window.innerWidth;
    const offset = 350; // adjust this based on pop size

    // let horizontal = "right";

    if (rect.bottom + offset > windowHeight) vertical = "top";
    else if (rect.top < offset) vertical = "bottom";

    // if (rect.left + offset > windowWidth) horizontal = "right";
    // else if (rect.right < offset) horizontal = "left";

    setPosition({ vertical });
  };

  useEffect(() => {
    checkPosition();

    // Re-check on resize and scroll for dynamic behavior
    window.addEventListener("resize", checkPosition);
    window.addEventListener("scroll", checkPosition, true);

    return () => {
      window.removeEventListener("resize", checkPosition);
      window.removeEventListener("scroll", checkPosition, true);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={`${containerClass ? ` ${containerClass}` : ""} relative`}>
      <button
        className={`rounded-full border-2 ${borderColor} ${small ? 'w-4 h-4' : 'w-5 h-5'}`}
        onClick={() => {
          setOpen((prev) => !prev);
          onClickCallBack();
        }}>
        <InfoQuestionIconSVG className={`m-auto ${small ? 'w-2 h-2' : ''}`} />
      </button>
      <ContentContainer
        open={open}
        direction={direction}
        responsive={responsive}
        verticalDirection={position.vertical}
        topCss={topCss}
        >
        {/* arrow */}
        <div className={`arrow-${direction} ${hideArrow ? 'hidden' : 'block'}`}>
          <ArrowIcon />
        </div>
        <div className="content-container">
          <div className="content">
            {/* title */}
            <p className="content-title">{(lang && content?.translateKey) ? t(content?.translateKey) : content?.label}</p>
            {/* content */}
            {
              lang && content?.translateKey ? 
              <Trans
                i18nKey={`description_${content.key}`}
                components={[
                  <span className="font-bold" />
                ]}
              />: 
              <p className="content-sub-title" dangerouslySetInnerHTML={{ __html: content?.description }}></p>
            }
          </div>
          {/* footer */}
          <div className="footer-continer">
            <div className="footer">
              {
                content?.leftButton?.url && 
                <PopButton
                  label={t(content?.leftButton?.label)}
                  withIcon={content?.leftButton?.withIcon}
                  type={content?.leftButton?.type}
                  url={content?.leftButton?.url}
                  showMediaHandle={openVideo}
                  titleName={titleName}
                />
              }    
              
              {
                content?.rightButton?.url && 
                <>
                  <DividerIcon />
                  <PopButton
                    title={content?.label}
                    label={content?.rightButton?.label}
                    withIcon={content?.rightButton?.withIcon}
                    type={content?.rightButton?.type}
                    url={content?.rightButton?.url}
                    showMediaHandle={openVideo}
                    titleName={titleName}
                  />
                </>
              }
            </div>
          </div>
        </div>
      </ContentContainer>
      {/* {
          (showMedia && url) && 
          <Suspense fallback={<Loading />}> 
          <MediaPreview url={url} hide={hideMediaHandle}/> 
          </Suspense> 
        } */}
    </div>
  );
}

const PopButton = ({ label, withIcon = false, type = "link", url = "" ,showMediaHandle,titleName,title=""}) => {
  let defaultClass = "footer-btn";
  if (withIcon) {
    defaultClass += " footer-icon";
  }
  if (type === "link") {
    return (
      <a className={defaultClass} href={url} target="_blank" rel="noreferrer">
        {withIcon ? <PlayIconSmallSVG /> : null}
        {label}
      </a>
    );
  }else if(type === "media"){
    // setShowMedia(true)
    return (
      <button className={defaultClass} onClick={()=>{showMediaHandle(url)}}>
        {withIcon ? <PlayIconSmallSVG /> : null}
        {label}
      </button>
    );
  }else if(type === "modal"){
    return (
      <button className={defaultClass} onClick={()=>{showMediaHandle(url);titleName(title)}}>
        {withIcon ? <PlayIconSmallSVG /> : null}
        {label}
      </button>
    );
  } else {
    return (
      <button className={defaultClass}>
        {withIcon ? <PlayIconSmallSVG /> : null}
        {label}
      </button>
    );
  }
};

const DividerIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="2"
      height="16"
      viewBox="0 0 2 16"
      fill="none">
      <path d="M1 0L1 16" stroke="#D0D0D0" />
    </svg>
  );
};

const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="12"
      viewBox="0 0 18 12"
      fill="none"
      style={{
        filter: "drop-shadow(rgba(0, 0, 0, 0.12) 0px -2px 2px)",
      }}>
      <path d="M8.66025 0L17.3205 12H0L8.66025 0Z" fill="white" />
    </svg>
  );
};

const ContentContainer = styled.div`
  width: 348px;
  position: absolute;
  top: 36px;
  z-index: 9999;

  ${({ direction }) => {
    if (direction === "right") {
      return `right: -24px;`;
    } else if (direction === "left") {
      return `left: -24px;`;
    }else{
       return `left: 1px;`;
    }
  }}

  ${({ verticalDirection, topCss, direction }) => {
    if (verticalDirection === "top") {
      // Honour direction when the popup flips above the icon. Without this a
      // "right" popup (which opens to the LEFT of the icon) was forced back to
      // the right and clipped at the modal edge.
      if (direction === "right") {
        return `right: -24px; left: auto; top: ${topCss};`;
      }
      return `left: 40px; top: ${topCss};`;
    } else {
      return ``;
    }
  }}

  padding: 24px;
  border-radius: 6px;
  background-color: #ffffff;

  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.12) !important;

  display: none;
  opacity: 0;
  transition: visibility 0s linear 0.33s, opacity 0.33s linear;

  ${({ open }) => {
    if (open) {
      return `
      display: block;
      opacity: 1;
      transition-delay: 0s;
      `;
    }
  }}



  ${({ verticalDirection, direction }) => {
    if (verticalDirection === "top") {
      // Left-opening popup: arrow sits on the popup's right edge, pointing at
      // the icon on its right.
      if (direction === "right") {
        return `
          .arrow-right {
            position: absolute;
            right: -14px;
            bottom: 1rem;
            transform: rotate(90deg);
          }
        `;
      }
      return `
        .arrow-left {
          position: absolute;
          left: -14px;
          bottom: 1rem;
          transform: rotate(-90deg);
        }
        .arrow-right {
          position: absolute;
          left: -14px;
          bottom: 1rem;
          transform: rotate(-90deg);
        }
      `;
    }
    else {
      return `
        .arrow-right {
          position: absolute;
          top: -12px;
          right: 24px;
        }

        .arrow-left {
          position: absolute;
          top: -12px;
        }
      `;
    }
  }}


  .content-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 18px;
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .content-title {
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
    color: #333333;
  }

  content-sub-title {
    font-size: 16px;
    line-height: 24px;
    color: #333333;
  }

  .footer-continer {
    width: 100%;
  }

  .footer {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 18px;
  }

  .footer-btn {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: #0c6ed1;
  }

  .footer-btn.footer-icon {
    display: flex;
    flex-direction: row;
    column-gap: 12px;
    align-items: center;
  }

  /* media queries */
  @media (max-width: 593px) {
    /* global*/
    width: 300px;
    padding: 15px;

    .arrow-left {
      left: 24px;
    }

    .arrow-right {
      right: 24px;
    }

    .content-title {
      font-size: 18px;
      line-height: 28px;
    }

    .content-sub-title {
      font-size: 14px;
      line-height: 20px;
    }

    .footer-btn {
      font-size: 14px;
      line-height: 20px;
    }
  }

  @media (max-width: 593px) {
    ${({ direction,responsive }) => {
      if (direction === "right") {
        return `right: -24px;`;
      } else {
        return `left: -${responsive?.left};`;
      }
    }}

    ${({ direction,responsive }) => {
      if (direction === "right") {
        return `right: -24px;
                .arrow-right {
                    right: ${responsive?.arrow_right};
                  }`;
      } else{
        return `left: -${responsive?.left};
              .arrow-left {
                left: ${responsive?.arrow_left};
              }
        `;
      }
    }}
  }

  @media (max-width: 429px) {
    width: 250px;

    ${({ direction, responsive }) => {
      if (direction === "right") {
        return `
          right: -${responsive?.right};
          .arrow-right {
            right: ${responsive?.right};
          }
        `;
      } else{
        return `
          left: -${responsive?.left};
          .arrow-left {
            left: ${responsive?.left};
          }
        `;
      }
    }}

    .content-container {
      gap: 8px;
    }

    .content-title {
      font-size: 16px;
      line-height: 24px;
    }

    .content-sub-title {
      font-size: 12px;
      line-height: 16px;
    }

    .footer-btn {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;
